import { WIZARD_STEP_ORDER } from '@onboarding/domain/value-objects';
import type { WizardStepKey } from '@onboarding/domain/value-objects';

/**
 * Resolves the zero-based index of a wizard step within the canonical order.
 *
 * @param step - Wizard step key
 * @returns Zero-based position in WIZARD_STEP_ORDER, or -1 if not found
 */
export const getWizardStepIndex = (step: WizardStepKey): number => WIZARD_STEP_ORDER.indexOf(step);
